import { Icon } from '@iconify/react';
import CountUp from 'react-countup';

const ProvinceCardComponent = ({ card, onViewDeptDetails, onViewPublicDetails }) => {
  const handleDeptClick = () => {
    onViewDeptDetails(card.title);
  };

  const handlePublicClick = () => {
    onViewPublicDetails(card.title);
  };

  return (
    <div className={`position-relative border radius-16 overflow-hidden h-100 ${card.cardClass}`}>
      {/* Cover image with dark overlay */}
      <div className="position-relative">
        <img
          src={card.cover}
          alt=""
          className="w-100 object-fit-cover"
          style={{ height: '120px' }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-50"></div>
      </div>
      
      <div className="ps-16 pb-16 pe-16 text-center mt--50">
        <img
          src={card.icon}
          alt={card.title}
          className="border br-white border-width-3-px w-120-px h-120-px rounded-circle object-fit-contain position-relative z-index-1 bg-white"
        />
        <h5 className="mb-0 mt-4 position-relative z-index-1" 
            style={{fontFamily: "'Merriweather', serif", fontWeight: '700', letterSpacing: '0.5px', fontSize: '1.5rem'}}>
          {card.title}
        </h5>
        <span className="text-secondary mb-16 position-relative z-index-1 d-block mt-1" 
              style={{fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: '0.95rem'}}>
          Plantation Statistics
        </span>
        
        {/* First row of stats */}
        <div className="center-border position-relative bg-light-green radius-8 p-16 d-flex align-items-center gap-4 mb-3">
          <div className="text-center w-50">
            <h4 className="mb-0 text-success" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '700', fontSize: '1.4rem'}}>
              <CountUp end={card.value.totalPlantation} duration={2} />
            </h4>
            <span className="text-secondary mb-0 d-block mt-1" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: '0.9rem'}}>
              Total Plants
            </span>
          </div>
          <div className="text-center w-50">
            <h4 className="mb-0 text-success" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '700', fontSize: '1.4rem'}}>
              <CountUp end={card.value.activeUsers} duration={2} />
            </h4>
            <span className="text-secondary mb-0 d-block mt-1" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: '0.9rem'}}>
              Active Users
            </span>
          </div>
        </div>

        {/* Second row of stats */}
        <div className="center-border position-relative bg-light-green radius-8 p-16 d-flex align-items-center gap-4">
          <div className="text-center w-50">
            <h4 className="mb-0 text-success" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '700', fontSize: '1.4rem'}}>
              <CountUp end={card.value.byGeneralPublic} duration={2} />
            </h4>
            <span className="text-secondary mb-0 d-block mt-1" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: '0.9rem'}}>
              By General Public
            </span>
          </div>
          <div className="text-center w-50">
            <h4 className="mb-0 text-success" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '700', fontSize: '1.4rem'}}>
              <CountUp end={card.value.byDepartment} duration={2} />
            </h4>
            <span className="text-secondary mb-0 d-block mt-1" style={{fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: '0.9rem'}}>
              By Department
            </span>
          </div>
        </div>
        
        {/* Buttons section */}
        <div className="row justify-content-center mt-16">
          <div className="col-md-6">
            <button 
              className="bg-success-50 text-success-700 border-success btn-outline-success bg-hover-success-900 hover-text-white p-12 text-md btn-md px-12 py-8 radius-8 d-flex align-items-center justify-content-center mt-16 fw-semi-bold gap-2 w-100"
              onClick={handleDeptClick}
              style={{fontFamily: "'Poppins', sans-serif", fontWeight: '600', fontSize: '0.95rem', transition: 'all 0.3s ease'}}
            >
              <Icon icon="mdi:office-building" className="icon text-xl line-height-1" />
              Department Details
            </button>
          </div>
          <div className="col-md-6">
  <button 
    className="bg-success-50 text-success-700 border-success btn-outline-success bg-hover-success-900 hover-text-white p-8 text-md btn-md px-12 py-8 radius-8 d-flex align-items-center justify-content-center mt-16 fw-semi-bold gap-2 w-100" // Reduced padding
    onClick={handlePublicClick}
    style={{fontFamily: "'Poppins', sans-serif", fontWeight: '600', fontSize: '0.85rem', transition: 'all 0.3s ease'}} // Font size remains reduced
  >
    <Icon icon="mdi:account-group" className="icon text-xl line-height-1" />
    General Public Details
  </button>
</div>
        </div>
      </div>
      
      {/* Add font imports */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@700&family=Poppins:wght@400;500;600;700&display=swap');
          .bg-light-green {
            background-color: rgba(76, 175, 80, 0.1);
          }
          .bg-hover-success-900:hover {
            background-color: #1b5e20 !important;
          }
          .hover-text-white:hover {
            color: white !important;
          }
        `}
      </style>
    </div>
  );
};

export default ProvinceCardComponent;